import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sf-network-error" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed } from 'vue'

import { offline } from '@/services/offline'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingError',
  setup(__props) {

const isOffline = computed(() => {
  return offline.isOffline
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!isOffline.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "sf-network-error__icon iconfont isummary-close" }, null, -1),
            _createElementVNode("span", { class: "sf-network-error__text" }, [
              _createTextVNode(" Can not load the data, please try "),
              _createElementVNode("a", { href: "javascript:window.location.reload(true)" }, "refreshing"),
              _createTextVNode(" the page. ")
            ], -1)
          ]))]))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "sf-network-error__icon iconfont isummary-close" }, null, -1),
            _createElementVNode("span", { class: "sf-network-error__text" }, "It looks like you’re offline. Please connect to the Internet and try again.", -1)
          ]))]))
    ])
  ]))
}
}

})